// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CRC1","colMin":"styles_colMin__4Zp1I"};